import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-hot-toast';
import { AuthContext } from '../context/AuthContext';

const PaymentConfirmation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking'); // checking | success | failed
  const sessionId = searchParams.get('session_id');
  const { loginWithToken } = useContext(AuthContext);

  useEffect(() => {
    if (!sessionId) {
      setStatus('failed');
      return;
    }

    const completeRegistration = async () => {
      try {
        // Verify payment and complete registration
        const res = await api.post('/api/complete-registration', { sessionId });
        if (res.data.success) {
          setStatus('success');
          toast.success('Payment completed successfully! Logging you in...');
          
          // Use the JWT token returned from the backend
          if (res.data.token && res.data.userId) {
            try {
              loginWithToken(res.data.token, res.data.userId);
              setTimeout(() => navigate('/dashboard'), 2000);
            } catch (loginError) {
              console.error('Login error:', loginError);
              setTimeout(() => navigate('/login'), 2000);
            }
          } else {
            setTimeout(() => navigate('/login'), 2000);
          }
        } else {
          setStatus('failed');
        }
      } catch (err) {
        console.error(err);
        setStatus('failed');
        toast.error(err.response?.data?.error || 'Failed to complete registration');
      }
    };

    // Try to complete registration immediately and retry every 3 seconds
    completeRegistration();
    const id = setInterval(completeRegistration, 3000);
    
    // Cleanup interval on unmount
    return () => clearInterval(id);
  }, [sessionId, navigate, loginWithToken]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center space-y-4 max-w-md w-full">
        {status === 'checking' && (
          <>
            <div className="loader mx-auto" />
            <h2 className="text-xl font-semibold">Completing your payment...</h2>
            <p className="text-gray-500 text-sm">This may take a few seconds.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-green-600 text-5xl">✓</div>
            <h2 className="text-xl font-semibold">Payment Complete!</h2>
            <p className="text-gray-500 text-sm">Your IRS audit protection is now active. Redirecting to dashboard...</p>
          </>
        )}
        {status === 'failed' && (
          <>
            <div className="text-red-600 text-5xl">✕</div>
            <h2 className="text-xl font-semibold">Payment Failed</h2>
            <p className="text-gray-500 text-sm">We couldn't complete your payment. Please <button onClick={() => navigate('/checkout')} className="text-indigo-600">try again</button> or contact support.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentConfirmation; 